module.exports = __webpack_public_path__ + "0ead56acaede64b9482daf01855e1671.MP3";